export default "__VITE_ASSET__9ae088e4__"